import { Formik, Form } from "formik";
import * as Yup from "yup";
import Input from "./Input";
import Select from "./Select";

const styles = {
  button: {
    marginTop: "20px",
    marginLeft: "5px",
    border: "1px solid #c0392b",
    padding: "20px 15px",
    backgroundColor: "#c0392b",
    color: "#fff",
    textTransform: "uppercase",
    cursor: "pointer",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "10px",
  },
  column: {
    padding: "0 0",
    width: "100%",
  },
  column2: {
    padding: "0 0",
    width: "100%",
    marginLeft: "10px",
  },
};

export default function FormCheckout({
  formShipping,
  handleSubmitFormShipping,
}) {
  return (
    <Formik
      initialValues={{
        email: formShipping.email,
        country: formShipping.country,
        firstName: formShipping.firstName,
        lastName: formShipping.lastName,
        address: formShipping.address,
        addressOptional: formShipping.addressOptional,
        city: formShipping.city,
        postalCode: formShipping.postalCode,
        phone: formShipping.phone,
      }}
      onSubmit={handleSubmitFormShipping}
      validationSchema={Yup.object({
        email: Yup.string().required("Requerido"),
        firstName: Yup.string().required("Requerido"),
        lastName: Yup.string().required("Requerido"),
        country: Yup.string().required("Requerido"),
        address: Yup.string().required("Requerido"),
        city: Yup.string().required("Requerido"),
        postalCode: Yup.string().required("Requerido"),
        phone: Yup.string().required("Requerido"),
      })}
    >
      <Form>
        <Input name="email" label="Introduzca el Email" />

        <h3 style={{ fontWeight: "300" }}>Shipping address</h3>

        <div style={styles.row}>
          <div style={styles.column}>
            <Select name="country" label="Seleccione País">
              <option value="">Seleccione ...</option>
              <option value="argentina">Argentina</option>
              <option value="brasil">Brasil</option>
              <option value="chile">Chile</option>
              <option value="colombia">Colombia</option>
              <option value="eeuu">Estados Unidos</option>
              <option value="mexico">Mexico</option>
              <option value="Panama">Panama</option>
              <option value="peru">Peru</option>
              <option value="venezuela">Venezuela</option>
            </Select>
          </div>
        </div>
        <div style={styles.row}>
          <div style={styles.column}>
            <Input name="firstName" label="Introduzca el nombre" />
          </div>

          <div style={styles.column2}>
            <Input name="lastName" label="Introduzca el apellido" />
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.column}>
            <Input name="address" label="Introduzca dirección de envío" />
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.column}>
            <Input
              name="addressOptional"
              label="Apartamento, casa, etc... opcional"
            />
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.column}>
            <Input name="postalCode" label="Código Postal" />
          </div>

          <div style={styles.column2}>
            <Input name="city" label="Ciudad" />
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.column}>
            <Input name="phone" label="Número de teléfono" />
          </div>
        </div>

        <button style={styles.button} type="submit">
          Continue to Payment
        </button>
      </Form>
    </Formik>
  );
}
